import { Run, UserPrivate } from '@pollination-solutions/pollination-sdk'
import { CSSProperties, ReactElement } from 'react'
import { APIClient } from '../hooks'

export enum RunTabs {
  details='details',
  debug='debug',
  workspace='workspace'
}

export interface RunCardProps {
  projectOwner: string
  projectName: string
  enableClick?: boolean
  run?: Run
  style?: CSSProperties
  authUser?: UserPrivate
  client?: APIClient
  getTab?: (tab: any) => any
  defaultTab?: RunTabs
  interval?: number
  getValue?: (run: Run) => any
  canWrite?: boolean
  localRun?: boolean
  loaderNode?: ReactElement<any, any>
}
